<template>
    <div>
        <navigation-bar Close/>
        <div class="main">
            <div v-html="content" class="policy m-4"></div>
            <div v-if="isDebug">{{systemMsg}}</div>
        </div>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>
</template>

<script>
import {notNull} from "@/util/common";
export default {
    name: "PrivacyPolicy",
    data() {
        return {
            isDebug: false,
            systemMsg: '',
            content:'',
            isLoading: false,
        }
    },
    created() {
        this.setupData();
    },
    mounted() {
        //TODO 測試用的版本訊息
        // if (process.env.VUE_APP_MODE !== "release") {
            this.isDebug = true;
            // this.systemMsg = 'api:' + process.env.VUE_APP_API_HOST + '\n v:' + process.env.VUE_APP_VERSION;
            this.getAppVersion();
        // }
    },
    methods: {
        setupData: function () {
            this.isLoading = true;
            //公告快訊
            this.$http.fetch`GetPrivacyPolicy${{
                brandId: this.brandId,
            }} ${json => {
                if (notNull(json.data)) {
                    this.content = json.data.content;
                }
                this.isLoading = false;
            }}`;
        },

        /** 檢查 google日曆 app */
        checkGoogleCalendar: function () {
            //再次檢查是不是 cordova，雖然在函式之外就檢查過
            if (this.$public.isCordova()) {
                let schema = '';
                if (this.$http.getOS()?.toLowerCase() === 'ios') {
                    schema = 'googlecalendar://';

                } else if (this.$http.getOS()?.toLowerCase() === 'android') {
                    schema = 'com.google.calendar';
                }

                if (this.$public.notNull(window.appAvailability) && schema !== '') {
                    window.appAvailability.check(
                        schema, // Package Name
                        function() {           // Success callback
                            alert('have google calendar');
                        },
                        function() {           // Error callback
                            alert('no google calendar');
                        }
                    );
                } else {
                    console.log(`no appAvailability ! schema:${schema}`);
                }
            }
        },

        /** 取得app版號 */
        getAppVersion: function () {
            let self = this;
            // eslint-disable-next-line no-prototype-builtins
            if (window.hasOwnProperty("cordova")) {
                //取得裝置上目前App的版本 https://github.com/sampart/cordova-plugin-app-version
                window.cordova.getAppVersion.getVersionNumber(function (version) {
                    self.$http.appVersion = version;
                    self.systemMsg = 'v:' + version;
                });
            }
        },
    }
}
</script>

<style lang="less" scoped>
    .action-bar {
        width: 100%;
        min-height: 35px;
        overflow: hidden;
        .back {
            padding: 10px 20px;
            img {
                width: 20px;
                height: 20px;
            }
        }
    }

</style>